<script setup lang="ts">
import type { Component } from 'vue'
import { UsersIcon } from '@heroicons/vue/24/outline'

const route = useRoute()

const iconComponents: Record<string, Component> = {
  'i-heroicons-users': UsersIcon,
}

const pageTitle = computed(() => route.meta.title)
const pageIcon = computed(() => String(route.meta.icon ?? ''))
const isImageIcon = computed(() => /\.(?:png|jpe?g|webp|svg|gif|ico)(?:\?.*)?$/.test(pageIcon.value))
const iconComponent = computed(() => iconComponents[pageIcon.value])
</script>

<template>
  <div>
    <NuxtLoadingIndicator />
    <NuxtLayout name="dashboard" cta="Contact us for a 1:1 consultation regarding all things related to your project's roadmap" contact>
      <template #header>
        <div class="flex items-center gap-4 text-brand-900">
          <img v-if="isImageIcon" :src="pageIcon" alt="" class="size-8">
          <component :is="iconComponent" v-else-if="iconComponent" class="size-8" aria-hidden="true" />
          <div class="shrink-0 text-sm font-semibold">
            {{ pageTitle }}
          </div>
        </div>
      </template>
      <slot />
    </NuxtLayout>
  </div>
</template>
